import { getPharosTokenClaims } from '../auth/get-pharos-token-claims';
import type { TelemetryAuthContext } from './types';

/**
 * Decode a Klareo JWT into the minimal auth context tracked with every telemetry item.
 *
 * Pure function — no React dependency, safe to call from both web and React Native.
 * Returns `null` when `token` is `null`, malformed, or does not carry the minimum
 * Pharos JWT claims (`tenantId`, `userId`) — callers should treat `null` as anonymous.
 *
 * @param token - Klareo JWT string, or `null` when the user is unauthenticated.
 * @returns The decoded auth context, or `null` when no valid context can be derived.
 */
export function toTelemetryAuthContext(token: string | null): TelemetryAuthContext | null {
  const claims = getPharosTokenClaims(token);
  if (!claims) return null;

  return {
    tenantId: claims.tenantId,
    userId: claims.userId,
  };
}
